import { apiURL, callAPI } from 'api/main';

interface ICancelInviteParams {
  matchId: number;
}

export default async (params: ICancelInviteParams): Promise<any> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/v3/sys/match/invites/cancel`,
      method: 'POST',
      needToken: true,
      params,
    });

    const data = res.request;

    if (data) {
      return data;
    }

    return null;
  } catch (ex) {
    return null;
  }
};
